angular.module('gym.bulkUpdates').controller('ShowBulkUpdateCtrl', ["$scope", "$rootScope", "$state", "$http", "loadingAnimation", "MasqueradingService", "AdminUserService", "flash", "ActionCable", "MembershipPlanCategories", "meta", "bulkUpdate", function($scope, $rootScope, $state, $http, loadingAnimation, MasqueradingService, AdminUserService, flash, ActionCable, MembershipPlanCategories, meta, bulkUpdate) {
  var bulkUpdateUrl, confirmFilters, getInitialTab, gym, unsubscribe;
  if (!(AdminUserService.has('admin_perform_bulk_record_updates') && MasqueradingService.isMasquerading())) {
    $state.go('gym.dashboard');
  }
  gym = $rootScope.gym;
  bulkUpdateUrl = `/gyms/${gym.id}/bulk_update/bulk_updates/${bulkUpdate.id}`;
  $scope.meta = meta;
  $scope.bulkUpdate = bulkUpdate;
  $scope.membershipPlanCategories = MembershipPlanCategories.getList({
    count: 1000
  }).$object;
  getInitialTab = function() {
    switch ($scope.bulkUpdate.status) {
      case 'update_complete':
      case 'update_failed':
      case 'updating':
      case 'queued_for_update':
      case 'ready_for_review':
        return 'update';
      case 'filter_confirmation_pending':
        return 'filters';
      default:
        return 'confirm';
    }
  };
  $scope.currentTab = getInitialTab();
  $scope.isTabDisabled = function(tab) {
    var initialTab, ref;
    initialTab = getInitialTab();
    switch (tab) {
      case 'filters':
        return (ref = $scope.bulkUpdate.status) === 'queued_for_update' || ref === 'updating' || ref === 'update_complete' || ref === 'update_failed';
      case 'confirm':
        return initialTab === 'filters';
      case 'update':
        return initialTab === 'filters' || initialTab === 'confirm';
    }
  };
  $scope.setTab = function(tab, skipCheck) {
    if ($scope.isTabDisabled(tab) && !skipCheck) {
      return;
    }
    return $scope.currentTab = tab;
  };
  unsubscribe = ActionCable.create({
    channel: 'BulkRecordUpdatesChannel',
    uuid: bulkUpdate.uuid
  }, function(message) {
    return $scope.reloadBulkUpdate();
  });
  $scope.$on('$destroy', function() {
    return unsubscribe();
  });
  $scope.reloadBulkUpdate = _.debounce(function() {
    return $http.get(bulkUpdateUrl).then(function(response) {
      return $scope.bulkUpdate = response.data;
    });
  }, 300);
  confirmFilters = function() {
    var url;
    url = `${bulkUpdateUrl}/confirm_filters`;
    return $http.put(url).then(function() {
      $scope.setTab('confirm', true);
      return loadingAnimation.hide();
    }, function() {
      flash.error = "Request could not be completed. Please try again";
      return loadingAnimation.hide();
    });
  };
  $scope.updateFilters = function(filters) {
    var params;
    params = {
      bulk_record_update: {
        filters_applied: filters
      }
    };
    loadingAnimation.show();
    return $http.put(bulkUpdateUrl, params).then(function() {
      return confirmFilters();
    }, function() {
      flash.error = "Request could not be completed. Please try again";
      return loadingAnimation.hide();
    });
  };
  return $scope.confirmChanges = function() {
    var url;
    loadingAnimation.show();
    url = `${bulkUpdateUrl}/confirm_column_changes`;
    return $http.put(url).then(function() {
      $scope.setTab('update', true);
      return loadingAnimation.hide();
    }, function() {
      flash.error = "Request could not be completed. Please try again";
      return loadingAnimation.hide();
    });
  };
}]);
